<div class="header" *puSpinner="isLoading | async">
  <h4 class="header-text">
    {{ 'itSupportDialog.header' | translateIn }}
  </h4>

  <button
    class="close"
    type="button"
    puButton
    size="m"
    uiType="quaternary"
    [onlyIcon]="true"
    (click)="close()">
    <pu-icon iconName="close" size="16" />
  </button>
</div>

<form [formGroup]="form" class="body" (ngSubmit)="submit()">
  <pu-select
    class="field"
    formControlName="issueType"
    valueField="issueType"
    nameField="issueType"
    [placeholder]="'itSupportDialog.issueType.placeholder' | translateIn"
    [label]="'itSupportDialog.issueType.label' | translateIn"
    [items]="issueTypes"
  />

  @if (form.controls.issueType.value && (form.controls.fields?.controls | keyvalue).length) {
    @for (groupObj of form.controls.fields.controls | keyvalue; track $index) {
      @if (groupObj.value; as group) {
        @switch (true) {
          @case (group.value['fieldId'] === 'description') {
            <pu-text-area
              class="field field--description"
              [rows]="4"
              [formControl]="group.controls['fieldValue']"
              [label]="group.value.label + (group.value.required ? '*' : '')"
            />
          }
          @case (!!group.value['allowedValues']?.length) {
            @if (group.value['parentFieldId']) {
              @if (form.controls.fields.controls[group.value['parentFieldId']].value; as parentFormValue) {
                @if (
                  parentFormValue['fieldValue'] &&
                  group.value['parentRelatedValues'][parentFormValue['fieldValue']];
                  as parentFieldMappedValues
                ) {
                  @if (parentFieldMappedValues['length']) {
                    @if (group.value['isMultiSelect']) {
                      <pu-multi-select
                        class="field field--related-select"
                        [formControl]="group.controls['fieldValue']"
                        [label]="group.value.label + (group.value.required ? '*' : '')"
                        [placeholder]="'itSupportDialog.select.placeholder' | translateIn"
                        [items]="parentFieldMappedValues | toSelectItems"
                      />
                    } @else {
                      <pu-select
                        class="field field--related-select"
                        [formControl]="group.controls['fieldValue']"
                        [label]="group.value.label + (group.value.required ? '*' : '')"
                        [placeholder]="'itSupportDialog.select.placeholder' | translateIn"
                        [items]="parentFieldMappedValues | toSelectItems"
                      />
                    }
                  }
                }
              }
            } @else {
              <pu-select
                class="field field--select"
                [formControl]="group.controls['fieldValue']"
                [label]="group.value.label + (group.value.required ? '*' : '')"
                [items]="group.value['allowedValues'] | toSelectItems"
                [placeholder]="'itSupportDialog.select.placeholder' | translateIn"
                (valueChange)="valueChange(group.value['fieldId'])"
              />
            }
          }
          @default {
            <pu-simple-input
              class="field"
              [formControl]="group.controls['fieldValue']"
              [label]="group.value.label + (group.value.required ? '*' : '')"
            />
          }
        }
      }
    }
  }

  <div class="actions">
    <button
      type="submit"
      puButton
      size="l"
      uiType="primary"
      [disabled]="form.invalid"
    >{{ 'itSupportDialog.text.createRequest' | translateIn }}</button>

    <button
      type="button"
      puButton
      size="l"
      uiType="secondary"
      (click)="close()"
    >{{ 'itSupportDialog.text.cancel' | translateIn }}</button>
  </div>
</form>
